import { jsx as _jsx } from "react/jsx-runtime";
import { UploadsTrackingPanel } from "@air/feature-uploads/ui";
import { Portal } from "@air/primitive-portal";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useAirModal } from "@air/provider-modal";
import { isFinishedUploadingSelector, isLarge } from "@air/redux-uploader";
import { useDeleteAllUploads } from "@air/upload-utils";
import { memo, useCallback } from "react";
import { BoardCollectionCancelAllUploadsModal } from "~/components/BoardCollection/BoardCollectionCancelAllUploadsModal";
import { useBoardCollectionUploadsManager } from "~/components/BoardCollection/hooks/useBoardCollectionUploadsManager";
import { metadataForPublicUploadSelector } from "~/store/publicUploadMetadata/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
import { sendAbortPublicMultipartUpload } from "~/utils/uploadApi/publicUploadApi/publicLargeUploadApi";
export const ContentCollectionUploadsManager = /*#__PURE__*/ memo(()=>{
    const { isAboveMediumScreen } = useBreakpointsContext();
    const store = useAirStore();
    const { deleteAllUploads } = useDeleteAllUploads();
    const [showCancelAllUploadsModal, closeCancelAllUploadsModal] = useAirModal(BoardCollectionCancelAllUploadsModal);
    const onDelete = useCallback(async (upload)=>{
        if (isLarge(upload) && !!upload.s3Info.uploadUrlInfo) {
            const uploadMetadata = metadataForPublicUploadSelector(store.getState(), upload.id);
            sendAbortPublicMultipartUpload({
                uploadUrlInfo: upload.s3Info.uploadUrlInfo,
                shortBoardId: uploadMetadata.shortBoardId
            });
        }
    }, [
        store
    ]);
    useBoardCollectionUploadsManager();
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "fixed inset-x-0 bottom-[120px] md:bottom-20 md:left-6 md:right-auto",
            children: /*#__PURE__*/ _jsx(UploadsTrackingPanel, {
                style: {
                    width: isAboveMediumScreen ? 324 : "100%"
                },
                summaryLocation: undefined,
                onCancelAllUploads: ()=>{
                    const isFinished = isFinishedUploadingSelector(store.getState());
                    if (isFinished) {
                        deleteAllUploads();
                    } else {
                        showCancelAllUploadsModal({
                            onCancelUpload: ()=>{
                                deleteAllUploads();
                                closeCancelAllUploadsModal();
                            }
                        });
                    }
                },
                onDeleteUpload: onDelete
            })
        })
    });
});
ContentCollectionUploadsManager.displayName = "ContentCollectionUploadsManager";
